<template>
  <div class="slider-info">
    <b-row class="no-gutters">
      <b-col cols="6" class="base-modelo">
        <div class="modelo">
          <span v-if="model > 0">Modelo {{ model }}</span>
        </div>
        <div class="base">
          <span v-if="base > 0">Base {{ base | currency }}</span>
        </div>
      </b-col>
      <b-col cols="6">
        <Icons :flags="flags" />
      </b-col>
      <b-col cols="4" md="6" class="titulo titulo-01">
        <span v-if="brand !== ''">Marca:</span>
      </b-col>
      <b-col cols="4" md="6" class="titulo titulo-02">
        <span v-if="make !== ''">Línea:</span>
      </b-col>
      <b-col cols="8" md="6" class="valor valor-01">
        <span v-if="brand !== ''">{{ brand }}</span>
      </b-col>
      <b-col cols="8" md="6" class="valor valor-02">
        <span v-if="make !== ''">{{ make }}</span>
      </b-col>
      <b-col cols="4" md="6" class="titulo titulo-03">
        <span v-if="cc !== ''">C.C.:</span>
      </b-col>
      <b-col cols="4" md="6" class="titulo titulo-04">
        <span v-if="color !== ''">Color:</span>
      </b-col>
      <b-col cols="8" md="6" class="valor valor-03">
        <span v-if="cc !== ''">{{ cc }}</span>
      </b-col>
      <b-col cols="8" md="6" class="valor valor-04">
        <span v-if="color !== ''">{{ color }}</span>
      </b-col>
      <b-col cols="4" md="6" class="titulo titulo-05">
        <span v-if="fuel !== ''">Combustible:</span>
      </b-col>
      <b-col cols="4" md="6" class="titulo titulo-06">
        <span v-if="mileage !== ''">Kilometraje / Millas:</span>
      </b-col>
      <b-col cols="8" md="6" class="valor valor-05">
        <span v-if="fuel !== ''">{{ fuel }}</span>
      </b-col>
      <b-col cols="8" md="6" class="valor valor-06">
        <span v-if="mileage !== ''">{{ mileage }}</span>
      </b-col>
      <b-col cols="4" md="6" class="titulo titulo-07">
        <span v-if="cilinders !== ''">Cilindros:</span>
      </b-col>
      <b-col cols="4" md="6" class="titulo titulo-08">
        <span v-if="doors !== ''">Puertas:</span>
      </b-col>
      <b-col cols="8" md="6" class="valor valor-07">
        <span v-if="cilinders !== ''">{{ cilinders }}</span>
      </b-col>
      <b-col cols="8" md="6" class="valor valor-08">
        <span v-if="doors !== ''">{{ doors }}</span>
      </b-col>
      <b-col cols="4" md="6" class="titulo titulo-09">
        <span v-if="keys !== ''">Llaves:</span>
      </b-col>
      <b-col cols="4" md="6" class="titulo titulo-10">
        <span v-if="source !== ''">Procedencia:</span>
      </b-col>
      <b-col cols="8" md="6" class="valor valor-09">
        <span v-if="keys !== ''">{{ keys }}</span>
      </b-col>
      <b-col cols="8" md="6" class="valor valor-10">
        <span v-if="source !== ''">{{ source }}</span>
      </b-col>
      <b-col cols="4" md="6" class="titulo featured titulo-11">
        <span v-if="code !== ''">Código:</span>
      </b-col>
      <b-col cols="4" md="6" class="titulo titulo-12">
        <span v-if="transmission !== ''">Transmisión:</span>
      </b-col>
      <b-col cols="8" md="6" class="valor featured valor-11">
        <span v-if="code !== ''">{{ code }}</span>
      </b-col>
      <b-col cols="8" md="6" class="valor valor-12">
        <span v-if="transmission !== ''">{{ transmission }}</span>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Icons from "../item/Icons";
import utils from "../../assets/js/utils";

export default {
  name: "SliderInfo",
  components: {
    Icons
  },
  props: {
    id: {
      type: String,
      default: "0"
    },
    model: {
      type: Number,
      default: 0
    },
    base: {
      type: Number,
      default: 0
    },
    brand: {
      type: String,
      default: ""
    },
    make: {
      type: String,
      default: ""
    },
    cc: {
      type: String,
      default: ""
    },
    color: {
      type: String,
      default: ""
    },
    fuel: {
      type: String,
      default: ""
    },
    mileage: {
      type: String,
      default: "0"
    },
    cilinders: {
      type: String,
      default: "0"
    },
    doors: {
      type: String,
      default: "0"
    },
    keys: {
      type: String,
      default: ""
    },
    source: {
      type: String,
      default: ""
    },
    code: {
      type: String,
      default: ""
    },
    transmission: {
      type: String,
      default: ""
    },
    flags: {
      type: Object,
      default: function() {
        return {};
      }
    }
  },
  filters: {
    currency: function(amount) {
      return utils.formatCurrency(amount);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/scss/partial";

.slider-info {
  background-color: $white;
  font-size: 0.9rem;
  line-height: 1.4rem;
  display: flex;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;

  @media (max-width: prev-viewport-max-size("xl")) {
    font-size: 0.8rem;
    line-height: 1.2rem;
  }

  @media (max-width: prev-viewport-max-size("lg")) {
    font-size: 0.6rem;
    line-height: 0.8rem;
  }

  @media (max-width: prev-viewport-max-size("md")) {
    font-size: 0.8rem;
    line-height: 1rem;
  }

  div.col,
  div[class^="col-"],
  div[class*=" col-"] {
    &.titulo {
      padding-top: 2px;
    }

    &.valor {
      padding-bottom: 5px;
      border-bottom: 1px solid $red;
      font-weight: $font-weight-bold;
    }

    &.featured {
      color: $red;
      font-weight: 700;
    }

    &:last-child,
    &:nth-last-child(2) {
      border-bottom: none;
      padding-bottom: 0;
    }

    &:nth-child(odd) {
      margin-left: 10px;
      margin-right: -10px;
    }
  }
}

.modelo {
  color: $red;
  font-size: 1.4rem;
  line-height: 1.5rem;
  font-weight: 700;
  text-transform: uppercase;

  @media (max-width: prev-viewport-max-size("xl")) {
    font-size: 1.2rem;
    line-height: 1.3rem;
  }

  @media (max-width: prev-viewport-max-size("lg")) {
    font-size: 0.9rem;
    line-height: 1rem;
  }

  @media (max-width: prev-viewport-max-size("md")) {
    font-size: 1.3rem;
    line-height: 1.5rem;
  }

  @media (max-width: prev-viewport-max-size("xs")) {
    font-size: 1rem;
    line-height: 1.1rem;
  }
}

.base {
  font-size: 1.3rem;
  line-height: 1.4rem;
  font-weight: 300;
  text-transform: uppercase;

  @media (max-width: prev-viewport-max-size("xl")) {
    font-size: 1.1rem;
    line-height: 1.2rem;
  }

  @media (max-width: prev-viewport-max-size("lg")) {
    font-size: 0.8rem;
    line-height: 0.9rem;
  }

  @media (max-width: prev-viewport-max-size("md")) {
    font-size: 1.1rem;
    line-height: 1.4rem;
  }

  @media (max-width: prev-viewport-max-size("xs")) {
    font-size: 0.8rem;
    line-height: 1rem;
  }
}

@media (max-width: prev-viewport-max-size("md")) {
  .slider-info {
    div.col,
    div[class^="col-"],
    div[class*=" col-"] {
      line-height: 1rem;
      padding: 0 5px;
      padding-top: 0 !important;
      padding-bottom: 0 !important;
      margin: 0 !important;
      border: 0 !important;
      min-height: 16px;
      flex-basis: 1 1 auto !important;
    }
    div.base-modelo {
      order: 0;
      line-height: 2rem;
      min-height: 32px;
    }
    div.icons {
      order: 1;
      line-height: 2rem;
      min-height: 32px;
    }
    div.titulo-01 {
      order: 2;
    }
    div.valor-01 {
      order: 3;
    }
    div.titulo-02 {
      order: 4;
    }
    div.valor-02 {
      order: 5;
    }
    div.titulo-03 {
      order: 6;
    }
    div.valor-03 {
      order: 7;
    }
    div.titulo-04 {
      order: 8;
    }
    div.valor-04 {
      order: 9;
    }
    div.titulo-05 {
      order: 10;
    }
    div.valor-05 {
      order: 11;
    }
    div.titulo-06 {
      order: 12;
    }
    div.valor-06 {
      order: 13;
    }
    div.titulo-07 {
      order: 14;
    }
    div.valor-07 {
      order: 15;
    }
    div.titulo-08 {
      order: 16;
    }
    div.valor-08 {
      order: 17;
    }
    div.titulo-09 {
      order: 18;
    }
    div.valor-09 {
      order: 19;
    }
    div.titulo-10 {
      order: 20;
    }
    div.valor-10 {
      order: 21;
    }
    div.titulo-11 {
      order: 22;
    }
    div.valor-11 {
      order: 23;
    }
    div.titulo-12 {
      order: 24;
    }
    div.valor-12 {
      order: 25;
    }
  }
}
</style>
